// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/Person.proto" (package "aware", syntax proto3)
// tslint:disable
import { Empty } from "../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * Enum used to represent if a user has confirmed this item
 *
 * @generated from protobuf enum aware.DataStatus
 */
export var DataStatus;
(function (DataStatus) {
    /**
     * @generated from protobuf enum value: DataStatusUnknown = 0;
     */
    DataStatus[DataStatus["DataStatusUnknown"] = 0] = "DataStatusUnknown";
    /**
     * Data has not been confirmed by user.
     *
     * @generated from protobuf enum value: DataStatusUnconfirmed = 1;
     */
    DataStatus[DataStatus["DataStatusUnconfirmed"] = 1] = "DataStatusUnconfirmed";
    /**
     * Data confirmed by user
     *
     * @generated from protobuf enum value: DataStatusConfirmed = 2;
     */
    DataStatus[DataStatus["DataStatusConfirmed"] = 2] = "DataStatusConfirmed";
    /**
     * Data has been rejected by the user.
     *
     * @generated from protobuf enum value: DataStatusRejected = 3;
     */
    DataStatus[DataStatus["DataStatusRejected"] = 3] = "DataStatusRejected";
})(DataStatus || (DataStatus = {}));
/**
 * Used to classify emails, events, etc into personal or work contexts.
 *
 * @generated from protobuf enum aware.DataContext
 */
export var DataContext;
(function (DataContext) {
    /**
     * @generated from protobuf enum value: UnspecifiedDataContext = 0;
     */
    DataContext[DataContext["UnspecifiedDataContext"] = 0] = "UnspecifiedDataContext";
    /**
     * @generated from protobuf enum value: UnknownDataContext = 1;
     */
    DataContext[DataContext["UnknownDataContext"] = 1] = "UnknownDataContext";
    /**
     * @generated from protobuf enum value: Personal = 2;
     */
    DataContext[DataContext["Personal"] = 2] = "Personal";
    /**
     * @generated from protobuf enum value: Work = 3;
     */
    DataContext[DataContext["Work"] = 3] = "Work";
})(DataContext || (DataContext = {}));
// enum PersonContactInformationContext {
//    UnspecifiedContactInformationContext = 0;
//    UnknownPersonContectInformationContext = 1;
//    Personal = 2;
//    Work = 3;
// }
/**
 * @generated from protobuf enum aware.PersonContactInformationSource
 */
export var PersonContactInformationSource;
(function (PersonContactInformationSource) {
    /**
     * @generated from protobuf enum value: UnspecifiedPersonContactInformationSource = 0;
     */
    PersonContactInformationSource[PersonContactInformationSource["UnspecifiedPersonContactInformationSource"] = 0] = "UnspecifiedPersonContactInformationSource";
    /**
     * @generated from protobuf enum value: ContactInformationUserInput = 1;
     */
    PersonContactInformationSource[PersonContactInformationSource["ContactInformationUserInput"] = 1] = "ContactInformationUserInput";
    /**
     * @generated from protobuf enum value: CalendarEventAttendee = 3;
     */
    PersonContactInformationSource[PersonContactInformationSource["CalendarEventAttendee"] = 3] = "CalendarEventAttendee";
    /**
     * @generated from protobuf enum value: EmailMessage = 4;
     */
    PersonContactInformationSource[PersonContactInformationSource["EmailMessage"] = 4] = "EmailMessage";
    /**
     * @generated from protobuf enum value: Contacts = 5;
     */
    PersonContactInformationSource[PersonContactInformationSource["Contacts"] = 5] = "Contacts";
})(PersonContactInformationSource || (PersonContactInformationSource = {}));
// @generated message type with reflection information, may provide speed optimized methods
class PersonName$Type extends MessageType {
    constructor() {
        super("aware.PersonName", [
            { no: 1, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "middle_name", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "suffix", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.PersonName
 */
export const PersonName = new PersonName$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonEmail$Type extends MessageType {
    constructor() {
        super("aware.PersonEmail", [
            { no: 1, name: "person_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "context", kind: "enum", T: () => ["aware.DataContext", DataContext] },
            { no: 100, name: "data_status", kind: "enum", T: () => ["aware.DataStatus", DataStatus] },
            { no: 101, name: "name_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.PersonEmail
 */
export const PersonEmail = new PersonEmail$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Person$Type extends MessageType {
    constructor() {
        super("aware.Person", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "person_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "names", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PersonName },
            { no: 4, name: "emails", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PersonEmail },
            { no: 5, name: "photo_urls", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "data_status", kind: "enum", T: () => ["aware.DataStatus", DataStatus] },
            { no: 101, name: "creation_source", kind: "enum", T: () => ["aware.PersonContactInformationSource", PersonContactInformationSource] },
            { no: 102, name: "source_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 103, name: "person_contexts", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["aware.DataContext", DataContext] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.Person
 */
export const Person = new Person$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserPersons$Type extends MessageType {
    constructor() {
        super("aware.UserPersons", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "persons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Person }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserPersons
 */
export const UserPersons = new UserPersons$Type();
/**
 * @generated ServiceType for protobuf service aware.FakeServicePerson
 */
export const FakeServicePerson = new ServiceType("aware.FakeServicePerson", [
    { name: "Bar", options: {}, I: Empty, O: Empty }
]);
